import React from 'react'
import { Popup } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'

import LKModal, { LKModalContainer } from 'shared/LKModal'
import LKButton from 'shared/LKButton'

const Control = ({ icon, text }) => <Popup position="bottom right" trigger={<LKButton alias={icon} />} content={text} />

// TODO: merge with LKErrorModal
const DetailsErrorModal = ({ modalInstanceName, message }) => (
  <LKModal
    name={modalInstanceName}
    heading={translate('LKMESSAGE-MSG_ERROR')}
    size="xxs"
    footer={
      <LKModal.Footer>
        <Control icon="copy" text="Copy to clipboard" />
        <Control icon="camera" text="Screenshot to clipboard" />
        <Control icon="globe" text="Screenshot to server" />
      </LKModal.Footer>
    }
    style={{ zIndex: 10000 }}
  >
    <div className="u-flex u-alignCenter u-justifyCenter">{message}</div>
  </LKModal>
)

export default LKModalContainer()(DetailsErrorModal)
